import { render } from "./EditorToolbarTextFont.vue?vue&type=template&id=08c45116"
import script from "./EditorToolbarTextFont.vue?vue&type=script&lang=js"
export * from "./EditorToolbarTextFont.vue?vue&type=script&lang=js"

import "./EditorToolbarTextFont.vue?vue&type=style&index=0&id=08c45116&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__